import React from 'react';
import classNames from 'classnames';
import style from 'assets/jss/material-dashboard-pro-react/views/services/FixedBusinessBroadband/filesStyle.js';
import { makeStyles } from '@material-ui/core';
import { translate } from 'components/Translation';
import FileUpload from 'components/CustomUpload/FileUpload';
import CustomTooltip from 'components/CustomTooltip/CustomTooltip';
import { Caption, CaptionBold, HeadingM } from 'components/Typography/Typography';
import CustomButton from 'components/CustomButtons/Button';
import Delete from '@material-ui/icons/DeleteOutlined';
import Circle from '@material-ui/icons/CheckCircleOutlined';
import KarokiePicture from 'assets/img/karokie.svg';

// @ts-ignore
const useStyles = makeStyles(style);

interface IFilesProps {
	handleAddKarokie: (file: { content?: string; name?: string }) => void;
	karokie: { content?: string; name?: string };
}

const FilesTab = ({ handleAddKarokie, karokie }: IFilesProps) => {
	const classes = useStyles();
	return (
		<div className={classes.filesContainer}>
			<div className={classes.filesTitleWrapper}>
				<HeadingM>{translate('add.new.line.fixed.files.description')}</HeadingM>
			</div>
			{karokie.content ? (
				<div className={classNames(classes.upload, classes.file)}>
					<Caption color="disabled-light">{translate(`add.new.line.fixed.files.location`)}</Caption>
					<CustomButton
						color="tertiary-light"
						id='deleteButton'
						className={classes.deleteIcon}
						justIcon
						size="lg"
						onClick={() => handleAddKarokie({ content: undefined, name: undefined })}
					>
						<Delete />
					</CustomButton>
					<div className={classes.fileNameContainer}>
						<Circle className={classes.success} />
						<CaptionBold inline className={classes.filename} disableMargin>
							{karokie.name}
						</CaptionBold>
					</div>
				</div>
			) : (
				<div className={classes.uploadItem}>
					<FileUpload
						iconPosition="right"
						size="md"
						fileMaxSize={2.5 * 1024 * 1024}
						className={classes.upload}
						text={translate(`add.new.line.fixed.files.location`)}
						onFileChange={(file: string) => {
							handleAddKarokie({ content: file });
						}}
						onMetadataChange={(data) => {
							handleAddKarokie({ name: data.name });
						}}
						showUploadButton
					/>
					<CustomTooltip>{translate(`add.new.line.fixed.files.tooltip`)}</CustomTooltip>
				</div>
			)}
			<div className={classes.karokieWrapper}>
				<img alt="karokie document" src={KarokiePicture} className={classes.karokie} />
			</div>
		</div>
	);
};

export default FilesTab;
